export const MLSIcon = ({ className = "h-6 w-6" }: { className?: string }) => {
  return (
    <svg
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* House shape */}
      <polygon points="50,5 95,40 85,40 85,95 15,95 15,40 5,40" fill="#1b6b3a" />
      {/* Door */}
      <rect x="38" y="62" width="24" height="33" fill="white" />
      {/* Window left */}
      <rect x="20" y="50" width="18" height="16" rx="2" fill="white" />
      {/* Window right */}
      <rect x="62" y="50" width="18" height="16" rx="2" fill="white" />
      {/* MLS text */}
      <text x="50" y="44" textAnchor="middle" fontSize="14" fontWeight="bold" fill="white" fontFamily="sans-serif">MLS</text>
    </svg>
  );
};
